<template>
  <ag-modal-container
    :title="$t('multiproject.title.createDraw')"
    fill-height
    @close="back"
  >
    <draw-form
      v-if="drawList"
      v-model="value"
      :draw-list="drawList"
      :data-table-loading="dataTableLoading"
      create
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-btn
        color="primary"
        class="mr-5"
        outlined
        @click="$options.downloadTemplate"
        v-text="$t('multiproject.template.download')"
      />
      <ag-upload-button
        color="primary"
        class="mr-5"
        outlined
        @upload="loadTemplate"
        v-text="$t('multiproject.template.upload')"
      />
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="$t('general.create')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import AgModalContainer from 'src/components/common/AgModalContainer'
import AgUploadButton from 'src/components/common/AgUploadButton'
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'
import { createEmptyDrawTemplate, readRoundListFromExcel } from 'src/services/drawExcelService'
import DrawForm from '../components/DrawForm'

export default {
  name: 'DrawCreateContainer',
  components: {
    AgModalContainer,
    AgUploadButton,
    DrawForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    dataTableLoading: false,
    drawList: null,
    value: {
      name: '',
      type: '',
      defaultDraw: false,
      relatedDraw: '',
      roundList: [],
    },
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.drawList = await Repositories.multiProject.draw.getList()
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async loadTemplate (file) {
      this.dataTableLoading = true
      try {
        const roundList = await readRoundListFromExcel(file)
        if (roundList.length !== 100) {
          this.showErrorNotification(this.$t('multiproject.template.uploadErrorLength'))
        }
        else {
          this.value = { ...this.value, roundList }
          this.showSuccessNotification(this.$t('multiproject.template.uploadSuccess'))
        }
      }
      catch (error) {
        this.showErrorNotification(this.$t('multiproject.template.uploadError'))
        throw error
      }
      finally {
        this.dataTableLoading = false
      }
    },
    async create () {
      this.loading = true
      try {
        await Repositories.multiProject.draw.post(this.value)
        this.showSuccessNotification(this.$t('multiproject.fields.success.drawCreated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
  downloadTemplate: createEmptyDrawTemplate,
}
</script>
